import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import CheckoutPage from "../../components/checkout/CheckoutPage";
import {checkCart, loadPaymentMethods} from "../../actions/cart";
import type {ApplicationState} from "../../reducers";
import {checkoutPageStepSet} from "../../reducers/orderReducer";

function mapStateToProps(state: ApplicationState, _ownProps) {
	return {
        isLoading: state.order.isLoading || state.cart.isLoading,
		isCartEmpty: !state.cart.items.length,
		showOrderFinishPage: state.order.showOrderFinishPage,
		isPaymentPending: !!state.order.order,
		page: state.order.currentPage,
		maxPage: state.order.maxPage,
		minPage: state.order.minPage,
		paypalClientId: state.cart.paypalClientId,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		setPage: page => dispatch(checkoutPageStepSet(page)),
		validateCart: () => dispatch(checkCart()),
		loadPaymentMethods: () => dispatch(loadPaymentMethods()),
	};
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CheckoutPage));
